import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { Ordinal } from '../../jscaip/Ordinal';
import { MartianChessMove } from './MartianChessMove';
import { MartianChessPiece } from './MartianChessPiece';
import { MartianChessState } from './MartianChessState';
export class MartianChessMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const currentPlayer = state.getCurrentPlayer();
        const playerTerritory = state.getPlayerTerritory(currentPlayer);
        let moves = [];
        for (const y of playerTerritory) {
            for (let x = 0; x < MartianChessState.WIDTH; x++) {
                const piece = state.getPieceAtXY(x, y);
                switch (piece) {
                    case MartianChessPiece.PAWN:
                        moves = moves.concat(this.getMovesForPawnAt(state, x, y));
                        break;
                    case MartianChessPiece.DRONE:
                        moves = moves.concat(this.getMovesForDroneAt(state, x, y));
                        break;
                    case MartianChessPiece.QUEEN:
                        moves = moves.concat(this.getMovesForQueenAt(state, x, y));
                        break;
                    default:
                        break;
                }
            }
        }
        return moves;
    }
    getMovesForPawnAt(state, x, y) {
        const coord = new Coord(x, y);
        const landingCoords = [];
        for (const diagonal of Ordinal.DIAGONALS) {
            const landingCoord = coord.getNext(diagonal);
            if (MartianChessState.isOnBoard(landingCoord)) {
                landingCoords.push(landingCoord);
            }
        }
        return this.addLegalMoves(state, coord, landingCoords);
    }
    addLegalMoves(state, startingCoord, validLandingCoords) {
        const moves = [];
        const firstPiece = state.getPieceAt(startingCoord);
        const canPromoteDrone = state.isTherePieceOnPlayerSide(MartianChessPiece.DRONE) === false;
        const canPromoteQueen = state.isTherePieceOnPlayerSide(MartianChessPiece.QUEEN) === false;
        const last = state.lastMove;
        for (const landingCoord of validLandingCoords) {
            const landedPiece = state.getPieceAt(landingCoord);
            if (landedPiece === MartianChessPiece.EMPTY) {
                // Moves
                this.add(moves, MartianChessMove.from(startingCoord, landingCoord).get(), last);
            }
            else if (state.isInPlayerTerritory(landingCoord)) {
                // Promotions
                const promotion = MartianChessPiece.tryMerge(landedPiece, firstPiece);
                if (promotion.isPresent()) {
                    const promoted = promotion.get();
                    const move = MartianChessMove.from(startingCoord, landingCoord).get();
                    if (promoted === MartianChessPiece.DRONE && canPromoteDrone) {
                        this.add(moves, move, last);
                    }
                    else if (promoted === MartianChessPiece.QUEEN && canPromoteQueen) {
                        this.add(moves, move, last);
                    }
                }
            }
            else {
                // Capture
                this.add(moves, MartianChessMove.from(startingCoord, landingCoord).get(), last);
            }
        }
        return moves;
    }
    add(moves, move, last) {
        const isCancelingLastMove = move.isUndoneBy(last);
        if (isCancelingLastMove === false) {
            moves.push(move);
        }
    }
    getMovesForDroneAt(state, x, y) {
        const coord = new Coord(x, y);
        const landingCoords = this.getLandingCoordsForLinearMove(coord, state, 2);
        return this.addLegalMoves(state, coord, landingCoords);
    }
    getLandingCoordsForLinearMove(startingCoord, state, maxDist) {
        const landingCoords = [];
        for (const dir of Ordinal.ORDINALS) {
            let dist = 1;
            let landingCoord = startingCoord.getNext(dir, dist);
            let possible = state.hasPieceAt(landingCoord, MartianChessPiece.EMPTY);
            while (possible) {
                landingCoords.push(landingCoord);
                dist++;
                landingCoord = startingCoord.getNext(dir, dist);
                possible = state.hasPieceAt(landingCoord, MartianChessPiece.EMPTY) && (dist < maxDist);
            }
            if (state.getOptionalPieceAt(landingCoord).isPresent()) {
                landingCoords.push(landingCoord);
            }
        }
        return landingCoords;
    }
    getMovesForQueenAt(state, x, y) {
        const startingCoord = new Coord(x, y);
        const landingCoords = this.getLandingCoordsForQueen(startingCoord, state);
        return this.addLegalMoves(state, startingCoord, landingCoords);
    }
    getLandingCoordsForQueen(startingCoord, state) {
        return this.getLandingCoordsForLinearMove(startingCoord, state, MartianChessState.HEIGHT);
    }
}
